import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTopButton from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import SEOHelmet from '@/components/base/SEOHelmet';
import SchemaOrg from '@/components/base/SchemaOrg';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [selectedCategory, setSelectedCategory] = useState(slug || 'films-tv');

  useEffect(() => {
    if (slug) setSelectedCategory(slug);
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [selectedCategory]);

  const category = categories.find((c) => c.slug === selectedCategory);
  const categoryArticles = articles.filter((a) => a.category === selectedCategory);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: category?.name || '分类' },
  ];

  const webpageSchema = {
    name: `${category?.name || '分类'} - 国产传媒`,
    url: `https://www.guochuanmedia.com/category/${selectedCategory}`,
    description: category?.description || '',
  };

  return (
    <>
      <SchemaOrg type="WebPage" data={webpageSchema} />
      <SEOHelmet
        title={`${category?.name || '分类'} - 内容列表`}
        description={category?.description || '国产传媒内容分类页面，浏览最新文章和资讯。'}
        keywords={`${category?.name || '内容'},国产传媒,内容分类,${category?.name || ''}文章`}
        canonicalUrl={`https://www.guochuanmedia.com/category/${selectedCategory}`}
      />

      <Navbar />
      <div className="pt-20">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="py-6">
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <div className="flex flex-wrap items-center gap-2 pb-8 border-b border-background-200/60 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  selectedCategory === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {category?.name}
            </h1>
            <p className="text-foreground-500 text-sm">{category?.description}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 pb-16">
            {categoryArticles.map((article) => (
              <ArticleCard key={article.slug} article={article} />
            ))}
            {categoryArticles.length === 0 && (
              <div className="col-span-full text-center py-20">
                <p className="text-foreground-400">暂无内容</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
      <ScrollToTopButton />
    </>
  );
}